import { CListGroup, CListGroupItem, CToast, CToastBody, CToastHeader } from '@coreui/react'
import React, { useEffect, useRef } from 'react'

interface ToastBaseProps {
  visible: boolean;
  title: string;
  message: string;
  data: any[];
  color: string;
  onClose: () => void;
  autohide?: boolean;
  delay?: number;
}

export const ToastBase: React.FC<ToastBaseProps> = ({
  visible,
  title,
  message,
  data,
  color,
  onClose,
  autohide = true,
  delay = 10000,
  ...props
}) => {
  const timerRef = useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {
    if (visible && autohide) {
      timerRef.current = setTimeout(() => {
        onClose();
      }, delay);
    }

    return () => {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }
    };
  }, [visible, autohide, delay, onClose]);

  return (
    <CToast
      visible={visible}
      onClose={onClose}
      {...props}
      style={{ zIndex: 1100 }}
      className="align-items-center m-5 position-fixed top-0 end-0"
    >
      <CToastHeader closeButton style={{ background: color }} className='text-white'>
        <div className="fw-bold me-auto">{title}</div>
      </CToastHeader>
      {data.length > 0 && (
        <CToastBody>
          <CListGroup flush>
            {data.map((err: any, index: number) => (
              <CListGroupItem key={index}>{err.error}</CListGroupItem>
            ))}
          </CListGroup>
        </CToastBody>
      )}
      {data.length === 0 && <CToastBody>{message}</CToastBody>}
    </CToast>
  )
}
